import * as React from 'react';
import { Flex, Avatar, Box, Container, Link } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { MotionBox, MotionFlex } from './motion';
import Header from './header';
import profile from "../vatars/avatar.jpg";
import { FiGithub, FiMail, FiLinkedin, FiFileText } from 'react-icons/fi';
import AboutP from './AboutPage';
import SkillsP from './SkillsPage';
import Github from '../Components/GithubCalendar';
import Stats from '../Components/Stats';
import ProjectsP from './ProjectPage';
import ContactUs from './Contact';

const ANIMATION_DURATION = 0.5;

const HomepageP = () => {
  const color = 'blue.400';

  return (
    <>
     <Container maxW="6xl" p={{ base: 5, md: 12 }}>
      <Flex direction={['column', 'column', 'row']}>
        <MotionBox
          opacity="0"
          initial={{
            translateX: -150,
            opacity: 0
          }}
          animate={{
            translateX: 0,
            opacity: 1,
            transition: {
              duration: ANIMATION_DURATION
            }
          }}
          m="auto"
          mb={[16, 16, 'auto']}
        >
          <MotionBox whileHover={{ scale: 1.2 }} rounded="full" shadow="lg">
            <Avatar
              size="2xl"
              showBorder={true}
              borderColor={color}
              src={profile}
            />
          </MotionBox>
        </MotionBox>
        <MotionFlex
          position="relative"
          ml={['auto', 'auto', 16]}
          m={['auto', 'initial']}
          w={['90%', '85%', '80%']}
          maxW="800px"
          opacity="0"
          justify="center"
          direction="column"
          initial={{
            opacity: 0,
            translateX: 150
          }}
          animate={{
            opacity: 1,
            translateX: 0,
            transition: {
              duration: ANIMATION_DURATION
            }
          }}
        >
          <Box position="relative">
            <MotionBox whileHover={{ translateY: -5 }} width="max-content">
              <Header underlineColor={color} mt={0} cursor="pointer" width="max-content">
                Hey!
              </Header>
            </MotionBox>
          </Box>
          <Box as="h2" fontSize="2xl" fontWeight="400" textAlign="left">
            I'm{' '}
            <Box as="strong" fontWeight="600">
              Rohit Prajapat
            </Box>{' '}
          </Box>
          <Box as="h2" fontSize="2xl" fontWeight="400" textAlign="left">
            <Box color={"red.400"} as="strong" fontWeight="600">
            Full stack web Developer
            </Box>{' '}
          </Box>
          <Box as="h2" fontSize="2xl" fontWeight="400" mt={5} textAlign="left">
          A Full Stack Developer who loves building projects.I am equipped with a variety of technologies and tools to help me build the best possible product.
          </Box>
          <Box mt={5} display="flex" alignItems="center">
            <Link href="https://github.com/Rohit20033" isExternal>
              <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: ANIMATION_DURATION }}
              >
                <FiGithub size={24} color={color} />
              </motion.div>
            </Link>
            <Link href="https://www.linkedin.com/in/rohit-prajapat-871b2a21a/" isExternal ml={4}>
              <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: ANIMATION_DURATION }}
              >
                <FiLinkedin size={24} color={color} />
              </motion.div>
            </Link>
            <Link href="mailto:rohitkumarprajapat303@gmail.com" isExternal ml={4}>
              <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: ANIMATION_DURATION }}
              >
                <FiMail size={24} color={color} />
              </motion.div>
            </Link>
            <Link href="https://drive.google.com/file/d/1XuuYqGIkyBi_ojJj1UK0EJ08loxtzs9f/view?usp=drive_link" isExternal ml={4}>
              <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: ANIMATION_DURATION }}
              >
                <FiFileText size={24} color={color} />
              </motion.div>
            </Link>
          </Box>
        </MotionFlex>
      </Flex>
    </Container>
    <AboutP/>
    <SkillsP/>
    <Github/>
    <Stats/>
    <ProjectsP/>
    <ContactUs/>
    
    </>
  );
};

export default HomepageP;
